import { Store } from "@ngrx/store";
import { PortalAppState } from "../store/reducer";
import { HttpRequest, HttpResponse } from "@angular/common/http";
import { ApplicationConstants } from "../app.constants";
import { CreateErrorMessage, CurrentState, CommonConstants } from "common-lib";

export class BaseInterceptor {
  constructor(protected store: Store<PortalAppState>, protected currentState: CurrentState<PortalAppState>) {
  }

  protected isPingCall(request: HttpRequest<any>) {
    if (request.url.includes('/utils/ping')) {
      return true;
    }
    return false;
  }

  protected isApiRequest(request: HttpRequest<any>) {
    if (request.url.includes('/api/')) {
      return true;
    }
    return false;
  }

}
